import { IntermediaryDiary, IntermediaryDiaryUpdatePayload } from './types'

export const formatIntermediaryDiaryUpdatePayload = (values: IntermediaryDiary): IntermediaryDiaryUpdatePayload => {
    const { intermediaryDiaryBuyer, intermediaryDiarySeller, ...rest } = values

    return {
        ...rest,
        intermediaryDiaryBuyer_group: intermediaryDiaryBuyer,
        intermediaryDiarySeller_group: intermediaryDiarySeller,
    }
}
